const Observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
      Observer.unobserve(entry.target);
    }
  });
}, {
  rootMargin: '0px 0px -20% 0px'
});
[...document.querySelectorAll('.js-in-view')].forEach(element => {
  Observer.observe(element);
});